import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
import { getPostByRouteName } from '@/documents/posts.js'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

const homeMetaEn = {
	appname: 'GBWhatsApp',
	lang: 'en',
	title: 'GB WhatsApp Download APK Latest Version (July 2026 Update)',
	keywords: 'GBWhatsApp, GB WhatsApp APK, download GB WhatsApp',
	description: 'Download GB WhatsApp APK latest version 2026 for Android. Get an updated GBWhatsApp build with simple installation, a lightweight file, and support for Android 5.0+.',
	link: [
		{
			rel: 'canonical',
			href: 'https://whatsgbdownloads.com/',
		},
	],
}

const homeMetaPt = {
	appname: 'GBWhatsApp',
	lang: 'pt',
	title: 'Baixar WhatsApp GB APK Última Versão | Atualização 2026',
	keywords: 'WhatsApp GB, WhatsApp GB APK, baixar WhatsApp GB',
	description: 'Baixe o WhatsApp GB APK última versão 2026 para Android. Use uma versão atualizada do WhatsApp GB, com instalação simples, arquivo leve e suporte para Android 5.0+.',
	link: [
		{
			rel: 'canonical',
			href: 'https://whatsgbdownloads.com/pt/',
		},
	],
}

const postBreadcrumb = [{ label: 'Blog', to: '/blog/' }]

function createPostMeta(routeName) {
	const post = getPostByRouteName(routeName)
	return {
		appname: 'GBWhatsApp',
		title: post.title,
		keywords: post.keywords,
		description: post.desc,
		breadcrumb: postBreadcrumb,
		breadcrumbTitle: post.title,
		link: [
			{
				rel: 'canonical',
				href: `https://whatsgbdownloads.com${post.url}`,
			},
		],
	}
}

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: homeMetaEn,
		component: Home,
	},
	{
		path: '/pt/',
		name: 'pt-gb',
		meta: homeMetaPt,
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp APK- Free & Safe`,
			keywords: 'Download GB WhatsApp , Download GB WhatsApp APK',
			description: `Get GB WhatsApp APK 2026 for Android instantly. Small, fast, and secure download with simple installation. Upgrade to the latest gbwhatsapp and enjoy a smooth messaging experience.`,
			breadcrumbTitle: 'Download GB WhatsApp APK',
			link: [
				{
					rel: 'canonical',
					href: 'https://whatsgbdownloads.com/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/blog/',
		name: 'blog',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWA Blog Collection — Tips and Tutorials`,
			keywords: 'gb whatsapp blogs',
			description: `Welcome to visit our blog page about GB WhatsApp. Find step-by-step instructions and hot topics here.`,
			breadcrumbTitle: 'Blog',
			link: [
				{
					rel: 'canonical',
					href: `https://whatsgbdownloads.com/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/show-blue-ticks-after-reply-in-gbwhatsapp/',
		name: 'show-blue-ticks-after-reply-in-gbwhatsapp',
		meta: createPostMeta('show-blue-ticks-after-reply-in-gbwhatsapp'),
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/gbwhatsapp-vs-fmwhatsapp/',
		name: 'gbwhatsapp-vs-fmwhatsapp',
		meta: createPostMeta('gbwhatsapp-vs-fmwhatsapp'),
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/fix-gb-whatsapp-ban/',
		name: 'fix-gb-whatsapp-ban',
		meta: createPostMeta('fix-gb-whatsapp-ban'),
		component: () => import('@/views/fix-gb-whatsapp-ban.vue'),
	},
	{
		path: '/privacy/',
		name: 'privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy',
			keywords: 'privacy policy',
			description: 'Read the privacy policy for whatsgbdownloads.com.',
			breadcrumbTitle: 'Privacy Policy',
			link: [
				{
					rel: 'canonical',
					href: 'https://whatsgbdownloads.com/privacy/',
				},
			],
		},
		component: () => import('@/views/privacy.vue'),
	},

]

const trailingSlashRedirects = constRoutesPc
	.filter((route) => route.path !== '/' && route.path.endsWith('/'))
	.map((route) => ({
		path: route.path.replace(/\/$/, ''),
		redirect: route.path,
	}))

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = [...constRoutesPc, ...trailingSlashRedirects]
export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})

	// 统一为所有非根路径补上尾斜杠
	router.beforeEach((to, from, next) => {
		if (to.path !== '/' && !to.path.endsWith('/')) {
			next({
				path: `${to.path}/`,
				query: to.query,
				hash: to.hash,
				replace: true,
			})
			return
		}
		next()
	})

	return router
}
